export const METRICS_USERS = ["MANAGER", "AANGARITA", "KANGARITA"];

export const getCurrentUsername = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return (user?.usuario || "").toUpperCase();
  } catch {
    return "";
  }
};

export const canViewRestrictedSections = () =>
  METRICS_USERS.includes(getCurrentUsername());

export const hasPermission = (key) => {
  try {
    const stored = localStorage.getItem("permisos");
    if (!stored) return false;
    return !!JSON.parse(stored)[key];
  } catch {
    return false;
  }
};

// Acceso permitido si es METRICS_USER (hardcoded) O tiene permiso en BD
export const canAccess = (key) =>
  canViewRestrictedSections() || hasPermission(key);
